import Guid from '@/services/Guid';
import { Col, Form, Input } from 'antd';
import type { IField } from './data';

const { Item } = Form;

export const Space: React.FC<IField> = (props) => {
    const { marginBottom, span, lg, name } = props;

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name + Guid.create()} xs={0} lg={lg || span} span={span}>
            <Item {...styling}>
                <Input hidden />
            </Item>
        </Col>
    );
};

export const Custom: React.FC<IField> = (props) => {
    const { onCustomClick, customComponent, name, span, lg, style, xs } = props;

    return (
        <Col onClick={onCustomClick} style={style} key={name} xs={xs ?? 0} lg={lg || span} span={span}>
            {customComponent}
        </Col>
    );
};
